import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { IOffer } from '../../interfaces/offers';
import { IAllProductsParams, IProductsParams, loadAllProducts, loadProductsByTag } from '../../services/products';

import { ISpecificProducts } from './filters';

export interface IState {
  productsList: {
    [key: string]: ISpecificProducts[];
  };
  specificProducts: {
    [key: string]: IOffer;
  };
}

const initialState: IState = {
  productsList: null,
  specificProducts: {},
};

const name = 'products';

const slice = createSlice({
  name,
  initialState,
  reducers: {
    setProductsList(state, { payload }) {
      state.productsList = payload;
    },
    setProductDetails(state, { payload }) {
      state.specificProducts[payload.id || payload._id] = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllProducts.fulfilled, (state, { payload }) => {
      state.productsList = payload;
    });
    builder.addCase(fetchProductsByTag.fulfilled, (state, { payload }) => {
      state.productsList = {
        ...state.productsList,
        ...payload,
      };
    });
  },
});

export const fetchAllProducts = createAsyncThunk<{ [key: string]: ISpecificProducts[] }, IAllProductsParams>(
  `${name}/fetchAllProducts`,
  async (params) => {
    return await loadAllProducts(params);
  },
);

export const fetchProductsByTag = createAsyncThunk<{ [key: string]: ISpecificProducts[] }, IProductsParams>(
  `${name}/fetchProductsByTag`,
  async (params) => {
    const products = await loadProductsByTag(params);

    return {
      [params.tag]: products,
    };
  },
);

const { reducer, actions } = slice;

export const { setProductsList, setProductDetails } = actions;

export default reducer;
